import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.sass'],
  animations: [
    trigger("smoothCollapse", [
      state("initial", style({
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        opacity: 0
      })),
      state("final", style({
        overflow: "hidden",
      })),
      transition("initial<=>final", animate("250ms"))
  ]),
  trigger('rotatedState', [
    state('default', style({ transform: 'rotate(0)' })),
    state('rotated', style({ transform: 'rotate(90deg)' })),
    transition('rotated <=> default', animate('250ms')),
  ])
  ],
  standalone: true,
  imports: []
})
export class AccordionItemComponent implements OnInit {
  @Input() title!: string;
  @Input() sectorId!: any;
  @Input() accordionType!: string;
  showBody = false;
  constructor() { }

  ngOnInit(): void {}

  toggle(event: any) {
    const headerEl = event.currentTarget as HTMLElement;
    const bodyEl   = headerEl.nextElementSibling as HTMLElement | null;
    if (!bodyEl) return;

    if (bodyEl.classList.contains("open-accordion-sector")) {
      bodyEl.classList.add("open-accordion-sector-fade");
      setTimeout(() => {
        bodyEl.classList.remove("open-accordion-sector", "open-accordion-sector-fade");
      }, 700);
    } else if (bodyEl.classList.contains("open-accordion-group-sector")) {
      bodyEl.classList.add("open-accordion-sector-fade");
      setTimeout(() => {
        bodyEl.classList.remove("open-accordion-group-sector", "open-accordion-sector-fade");
      }, 700);
    }

    // toggle your Angular-open flag
    this.showBody = !this.showBody;
  }
}
